import React, { ComponentProps, ReactNode } from "react";

import { InfoSmIcon } from "../Icons";
import { PopoverContentProps } from "@radix-ui/react-popover";
import { IconControl } from "../Button";
import { DialogRoot } from "./Root";
import { DialogTrigger } from "./Trigger";
import { DialogContent } from "./Content";
import { DialogTitle } from "./Title.styles";
import { DialogDescription } from "./Description.styles";
import { TitleRow } from "./Dialog.styles";

const defaultTrigger = (
  <IconControl aria-label="info-trigger">
    <InfoSmIcon />
  </IconControl>
);

export interface DialogProps extends ComponentProps<typeof DialogRoot> {
  trigger?: ReactNode;
  title?: ReactNode;
  description?: ReactNode;
  link?: ReactNode;
  className?: string;
  align?: PopoverContentProps["align"];
  side?: PopoverContentProps["side"];
  size?: "large" | "medium";
  sticker?: ReactNode;
  tag?: ReactNode;
  tooltip?: ReactNode;
  onOpenChange?: (isOpen: boolean) => void;
  onHoverChange?: (isHovered: boolean) => void;
}

export const Dialog = ({
  title,
  description,
  link,
  trigger = defaultTrigger,
  align = "start",
  side = "bottom",
  size,
  sticker,
  tag,
  tooltip,
  onOpenChange,
  onHoverChange,
  ...props
}: DialogProps) => {
  return (
    <DialogRoot onOpenChange={onOpenChange} {...props}>
      <DialogTrigger onHoverChange={onHoverChange}>{trigger}</DialogTrigger>
      <DialogContent align={align} side={side} className="dialog-content" size={size}>
        <TitleRow>
          {title && <DialogTitle>{title}</DialogTitle>}
          {tag && tooltip}
        </TitleRow>
        {description && <DialogDescription>{description}</DialogDescription>}
        {sticker && sticker}
        {link && link}
      </DialogContent>
    </DialogRoot>
  );
};
